angular.module("accordionIntegrazioneInformazioni.components", [])
    .component("accordionIntegrazioneInformazioni", {
        templateUrl: "ng/components/accordionIntegrazioneInformazioni/accordionIntegrazioneInformazioni.view.html",
        bindings: {
            instantModel: '=',
        },
        controllerAs: "IntegrazioneInformazioniCtrl",
        controller: function (
            $modalService,
            $configService,
            Pf,
            $timeout,
            $location,
            $instantService,
            $rootScope,
            $typeDomainService
        ) {

            var self = this;
            self.$onInit = function () {
                self.instantModel = self.instantModel;
                var tempPf = self.instantModel.financialCustomer.metadata.riUserF.listaPf.filter(function (elem) {
                    return elem.cf == $configService.getUser().identifier;
                });
                self.user = Pf.build(tempPf[0]).setDefaultPfValues();

                console.log(self.user);
                getListaEntiRilascio();
                $timeout(function () {
                    $(".financial-leasing__footer").css("z-index", "-1");
                    $modalService.openModal('censusPerson');
                }, 500);

            }

            self.uploadInfo = function (pf) {
                $instantService.updatePersonalActivity(self.instantModel.appIlTransaction.id, Pf.build(pf))
                    .then(function (response) {
                        console.log(response)
                        $modalService.closeModal("censusPerson");
                        $(".financial-leasing__footer").css("z-index", "2");
                        $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                        });
                        console.log('Reindirizzamento alla home');
                        $location.path("/");
                    })
                    .catch(function (error) {
                        console.log(error);
                        $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                        });

                    })

            }

            self.goBack = function () {
                $location.path("/");
            }

            var getListaEntiRilascio = function () {
                $typeDomainService
                    .getDomainSet("RI_DROPDOWN_DOMAINS", "AUTHORITY_TYPE")
                    .then(function (response) {
                        self.listaEntiRilascio = response.domainList;
                    });
            }

        }
    })